import React from 'react';
import SearchInput from './SearchInput';
import Button from '../primitives/Button';

/**
 * Reference "Removal Reports" table shell: title bar + search + export + children.
 */
export default function TablePanel({
  title,
  subtitle,
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search',
  exportLabel = 'Export',
  onExport,
  exportDisabled,
  action,
  children,
  className = '',
}) {
  return (
    <div className={`app-table-panel ${className}`.trim()}>
      <div className="app-table-toolbar">
        <div>
          <h2 className="app-table-toolbar__title">{title}</h2>
          {subtitle && (
            <p className="text-[12px] mt-0.5" style={{ color: 'var(--text-muted)' }}>
              {subtitle}
            </p>
          )}
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {searchValue != null && onSearchChange && (
            <SearchInput
              value={searchValue}
              onChange={onSearchChange}
              placeholder={searchPlaceholder}
              className="w-[200px] sm:w-[240px]"
            />
          )}
          {onExport && (
            <Button
              variant="secondary"
              size="sm"
              onClick={onExport}
              disabled={exportDisabled}
            >
              {exportLabel}
            </Button>
          )}
          {action}
        </div>
      </div>
      <div className="app-table-panel__body">{children}</div>
    </div>
  );
}
